module.exports = __webpack_public_path__ + "img/dengnavicon3.4731543b.png";